export default __webpack_public_path__ + "static/237-1d50f369cd25cecba17051ff02543177.gif";